export const formatBooleanLabel = (value: unknown): string => {
  if (value === null || value === undefined || value === '') return '-';
  if (value === true || value === 'true') return 'Sí';
  if (value === false || value === 'false') return 'No';
  return String(value);
};

export const hasWeighingData = (data: {
  weighting_percentage?: number | null;
  weighting_amount?: number | null;
  category?: string | null;
}): boolean =>
  data.weighting_percentage != null ||
  data.weighting_amount != null ||
  (data.category != null && data.category !== '');

export const isManualWeightingState = (data: {
  is_certificado_pyme?: boolean;
  is_manual_weighting?: boolean;
  weighting_percentage?: number | null;
  weighting_amount?: number | null;
  category?: string | null;
}): boolean => {
  if (data.is_manual_weighting === true) return true;
  if (data.is_certificado_pyme === true) return false;
  return hasWeighingData(data);
};
